interface Props {
  size?: number
  className?: string
}

export const UploadFileDeleteIcon = ({ size = 24, className = '' }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_132_651">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_132_651)">
        <circle opacity="0.05" cx="12" cy="12" r="12" fill="white" />
        <path
          opacity="0.6"
          d="M17.3862 8.70703C17.6624 8.70703 17.8862 8.93089 17.8862 9.20703C17.8862 9.48317 17.6624 9.70703 17.3862 9.70703H16.7847V15.3594C16.7845 16.7398 15.6651 17.8592 14.2847 17.8594H9.71533C8.4208 17.8594 7.35589 16.8751 7.22803 15.6143L7.21533 15.3594V9.70703H6.61377C6.33763 9.70703 6.11377 9.48317 6.11377 9.20703C6.11377 8.93089 6.33763 8.70703 6.61377 8.70703H17.3862ZM8.21533 9.70703V15.3594L8.22314 15.5127C8.30012 16.2689 8.9388 16.8594 9.71533 16.8594H14.2847C15.1129 16.8592 15.7845 16.1876 15.7847 15.3594V9.70703H8.21533Z"
          fill="white"
        />
        <path
          opacity="0.6"
          d="M8.43787 6.90039H15.5622"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          opacity="0.6"
          d="M10.6666 12L10.6666 14"
          stroke="white"
          strokeLinecap="round"
        />
        <path
          opacity="0.6"
          d="M13.3334 12L13.3334 14"
          stroke="white"
          strokeLinecap="round"
        />
      </g>
    </svg>
  )
}
